export type TrueSearchFlagMode = 'strict' | 'comment-focus';

const STRICT_TRUE_SEARCH_VALUES = new Set(['1', 'true']);
const COMMENT_FOCUS_TRUE_SEARCH_VALUES = new Set([
  ...STRICT_TRUE_SEARCH_VALUES,
  'yes',
  'y',
  'comment',
  'reply',
]);

export function normalizeSearchString(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const normalized = value.trim().toLowerCase();
  return normalized.length > 0 ? normalized : undefined;
}

export function normalizeOptionalSearchString(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const normalized = value.trim();
  return normalized.length > 0 ? normalized : undefined;
}

export function parsePositiveIntegerSearchValue(value: unknown): number | undefined {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value > 0 ? value : undefined;
  }

  const normalized = normalizeSearchString(value);
  if (!normalized || !/^\d+$/.test(normalized)) {
    return undefined;
  }

  const parsed = Number(normalized);
  return parsed > 0 ? parsed : undefined;
}

export function parseTrueSearchFlag(
  value: unknown,
  mode: TrueSearchFlagMode = 'strict',
): boolean {
  if (value === true || value === 1) {
    return true;
  }

  const normalized = normalizeSearchString(value);
  if (!normalized) {
    return false;
  }

  const acceptedValues = mode === 'comment-focus'
    ? COMMENT_FOCUS_TRUE_SEARCH_VALUES
    : STRICT_TRUE_SEARCH_VALUES;

  return acceptedValues.has(normalized);
}

export function normalizeTrueSearchFlag(
  value: unknown,
  mode: TrueSearchFlagMode = 'strict',
): true | undefined {
  return parseTrueSearchFlag(value, mode) ? true : undefined;
}
